'use es6';

export default new RegExp(/[\u30A0-\u30FF]/);